import { Mark } from '@tiptap/core'

/**
 * FontSize extension for TipTap
 * Allows setting font size on selected text via inline styles
 */
export const FontSize = Mark.create({
    name: 'fontSize',
    addOptions() {
        return {
            types: ['textStyle'],
        }
    },
    addAttributes() {
        return {
            fontSize: {
                default: null,
                parseHTML: element => {
                    const fontSize = element.style.fontSize
                    return fontSize ? fontSize.replace('px', '') : null
                },
                renderHTML: attributes => {
                    if (!attributes.fontSize) {
                        return {}
                    }
                    return {
                        style: `font-size: ${attributes.fontSize}px`,
                    }
                },
            },
        }
    },
    parseHTML() {
        return [
            {
                tag: 'span[style*="font-size"]',
                getAttrs: element => {
                    const fontSize = element.style.fontSize
                    return fontSize ? { fontSize: fontSize.replace('px', '') } : null
                },
            },
        ]
    },
    renderHTML({ HTMLAttributes }) {
        return ['span', HTMLAttributes, 0]
    },
    addCommands() {
        return {
            setFontSize: (fontSize) => ({ chain }) => {
                return chain()
                    .setMark(this.name, { fontSize })
                    .run()
            },
            unsetFontSize: () => ({ chain }) => {
                return chain()
                    .unsetMark(this.name)
                    .run()
            },
        }
    },
})
